import { defaultSections } from "@reactive-resume/schema";
import { RichInput } from "@reactive-resume/ui";
import { cn } from "@reactive-resume/utils";

import { AiActions } from "@/client/components/ai-actions";
import { useResumeStore } from "@/client/stores/resume";

import { ColumnBadge } from "./shared/column-badge";
import { EditableSectionName } from "./shared/editable-name";
import { getSectionIcon } from "./shared/section-icon";
import { SectionOptions } from "./shared/section-options";

export const SummarySection = () => {
  const setValue = useResumeStore((state) => state.setValue);
  const section = useResumeStore(
    (state) => state.resume.data.sections.summary ?? defaultSections.summary,
  );

  return (
    <section id="summary" className="grid gap-y-3">
      <header className="flex items-center justify-between">
        <div className="flex items-center gap-x-2">
          {getSectionIcon("summary")}
          <EditableSectionName id="summary" name={section.name} />
        </div>

        <div className="flex items-center gap-x-1">
          <ColumnBadge id="summary" />
          <SectionOptions id="summary" />
        </div>
      </header>

      <main className={cn(!section.visible && "opacity-50")}>
        <RichInput
          content={section.content}
          onChange={(value) => setValue("sections.summary.content", value)}
          footer={(editor) => (
            <AiActions value={editor.getHTML()} onChange={editor.commands.setContent} sectionType="summary" />
          )}
        />
      </main>
    </section>
  );
};
